import type { ReactNode } from "react";

/**
 * Lightweight collapsible section built on native <details>/<summary> — keyboard
 * accessible, no JS state needed. Used to tuck secondary meet actions (carpool,
 * notes, invites, calendar) out of the way so the primary flow (RSVP, who's
 * going, lineup) stays front and center.
 */
export function Collapsible({
  title,
  icon,
  hint,
  defaultOpen = false,
  children,
}: {
  title: string;
  icon?: string;
  hint?: string;
  defaultOpen?: boolean;
  children: ReactNode;
}) {
  return (
    <details className="collapsible card" open={defaultOpen}>
      <summary className="collapsible-summary">
        <span className="collapsible-title">
          {icon && <span aria-hidden="true">{icon} </span>}
          {title}
        </span>
        {hint && <span className="muted collapsible-hint">{hint}</span>}
        <span className="collapsible-chevron" aria-hidden="true">
          ›
        </span>
      </summary>
      <div className="collapsible-body">{children}</div>
    </details>
  );
}
